<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden" style="width: 95%; margin: 0 auto;">
    <h1 class="text-center lifedi-color m-3">
        จัดการคอร์สเรียน
    </h1>

    <div class="row d-flex pb-4 justify-content-center">
        <input type="text" class="form-control search" placeholder="ค้นหาคอร์สเรียน" name="searchCourse"
            [(ngModel)]="search" (keyup)="searching()">
    </div>

    <!-- not search  -->
    <nz-table *ngIf="!isSearch" #groupingTable [nzData]="allCourse" nzBordered nzSize="large"
        class="table table-striped">
        <thead>
            <tr>
                <th class="text-center">รหัสคอร์ส</th>
                <th class="text-center">ชื่อคอร์สเรียน</th>
                <th class="text-center">สถานะ</th>
                <th class="text-center">ผู้มีสิทธิ์จัดการคอร์ส</th>
                <th class="text-center">ข้อความ</th>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.COURSE_ID }}</td>
                <td class="text-center">{{ data.COURSE_NAME }}</td>
                <td class="text-center">
                    <span *ngIf="data.COURSE_STATUS === 0">Active</span>
                    <span *ngIf="data.COURSE_STATUS === 1">Inactive</span>
                    <span *ngIf="data.COURSE_STATUS === 99">Draft</span>
                    <span *ngIf="data.COURSE_STATUS === 999">Incomplete</span>
                </td>
                <td class="text-center">{{ data.USERNAME }}</td>
                <td class="text-center">
                    <a style="cursor: pointer;" (click)="privateChat(data.COURSE_ID)">
                        <img src="../../../../assets/email-black.png" style="width: 20px;">
                        <span *ngIf="data.MESSAGE_ALERT > 0"
                            [matBadge]="data.MESSAGE_ALERT >= 99 ? '99+' : data.MESSAGE_ALERT"
                            matBadgeOverlap="false"></span>
                    </a>
                </td>
            </tr>
        </tbody>
    </nz-table>
    <!-- not search -->

    <!-- search -->
    <nz-table *ngIf="isSearch" #groupingTable [nzData]="searchCourse" nzBordered nzSize="large">
        <thead>
            <tr>
                <th class="text-center">รหัสคอร์ส</th>
                <th class="text-center">ชื่อคอร์สเรียน</th>
                <th class="text-center">สถานะ</th>
                <th class="text-center">ผู้มีสิทธิ์จัดการคอร์ส</th>
                <th class="text-center">ข้อความ</th>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let data of groupingTable.data">
                <td class="text-center">{{ data.COURSE_ID }}</td>
                <td class="text-center">{{ data.COURSE_NAME }}</td>
                <td class="text-center">{{ data.COURSE_STATUS }}</td>
                <td class="text-center">{{ data.USERNAME }}</td>
                <td class="text-center">
                    <a style="cursor: pointer;" (click)="privateChat(data.COURSE_ID)">
                        <img src="../../../../assets/email-black.png" style="width: 20px;">
                        <span *ngIf="data.MESSAGE_ALERT > 0"
                            [matBadge]="data.MESSAGE_ALERT >= 99 ? '99+' : data.MESSAGE_ALERT"
                            matBadgeOverlap="false"></span>
                    </a>
                </td>
            </tr>
        </tbody>
    </nz-table>
    <!-- search -->
</div>

<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>